import * as React from 'react';
import * as CSSModules from 'react-css-modules';

const styles = require('./press.less');

@CSSModules(styles)
class Press extends React.Component<{}> {
    render() {
        return (
            <div>
                <iframe src={__('routes.press.aem')} styleName="iframe" />
            </div>
        );
    }
}

export { Press };
